import alert from '../../helpers/alert';
import api from '../../plugins/api';

const sendVerifyCode = ({ phone, dealId }) => {
  return api
    .get('/api/resource/sendVerifyCode', { phone, dealId })
    .then(() => {
      alert.success('ÐÐ¾Ð´ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½', {
        autoClose: 3000,
      });
    })
    .catch(() => {
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ¾Ð´ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ');
    });
};

export default sendVerifyCode;
